import {AuthService} from "./AuthService";

export class BotGroupService {

    url = `bot_groups/`;

    getBotGroups() {
        return AuthService.apiGet(this.url).then(res => res.data.data);
    }

    spike(bot_group_id, units) {
        return AuthService.apiPost(this.url + 'spike/', {bot_group_id: bot_group_id, units: units}).then(res => res.data.data);
    }
}
